import React from 'react';
import { Select } from 'antd';

export const renderCommonPaginationTotal = (total, range, params) => {
    const {
        pagination,
        handleTableChange,
        searchFilters = {},
        sortedInfo = {}
    } = params;

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ marginRight: 8, position: 'absolute', left: '13rem' }}>
                {range[0]}-{range[1]} of {total} results
            </span>
            <div>
                <span style={{ marginRight: 4 }}> Go to page:</span>
                <Select
                    size="small"
                    value={pagination.current || 1}
                    className="custom-page-select"
                    onChange={(page) => {
                        const newPagination = { ...pagination, current: page };
                        handleTableChange(
                            newPagination,
                            searchFilters,
                            sortedInfo
                        );
                    }}
                >
                    {Array.from(
                        { length: Math.ceil(total / (pagination.pageSize || 10)) },
                        (_, i) => (
                            <Select.Option key={i + 1} value={i + 1}>
                                {i + 1}
                            </Select.Option>
                        )
                    )}
                </Select>
            </div>
        </div>
    );
};


const reportNames = [
    "Quarterly Sales Analysis", "Inventory Reconciliation", "User Access Audit",
    "Market Trend Report", "System Performance Log", "Compliance Checklist"
];

const statuses = ["Processed", "Processing", "Failed"];

export const staticData = Array.from({ length: 50 }, (_, i) => {
    const id = i + 1;
    const randomValue = globalThis.crypto.getRandomValues(new Uint32Array(1))[0];
    const status = statuses[randomValue % statuses.length];

    return {
        // Unique ID matching your rowKey prop
        bidNo: `BID-${1000 + id}`,
        reportName: `${reportNames[i % reportNames.length]} #${id}`,
        requestedDate: `2024-05-${(i % 28) + 1} 14:30:05`,
        durationRange: "2024-01-01 to 2024-03-31",
        requestedFilters: i % 3 === 0 ? "Region: APAC" : "Status: All",
        reportStatus: status,
        isDownloadRequired: status === "Processed" ? "yes" : "no",
        fileName: `report_export_${id}.xlsx`,
    };
});